
export function setParam(key, value) {
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	window.gtag = gtag;
	gtag("set", {[key]: value});
}

export function customEvent(eventName, params = {}) {

	//gtag
	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	window.gtag = gtag;
	gtag('event', eventName, params);

	if (typeof CS_CONF !== "undefined" && window._uxa) {
		window._uxa.push(["trackPageEvent", eventName]);
	}
}

export function injectHotjar() {
	const id = "363f270db6db4";
	const path = window.location.pathname + window.location.hash.replace("#", "?__");
	window._uxa = window._uxa || [];

	function readCookie(name) {
		try {
			const m = document.cookie.match(
				new RegExp("(?:^|;\\s*)" + name.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&") + "=([^;]*)")
			);
			return m ? decodeURIComponent(m[1]) : undefined;
		} catch {
			return undefined;
		}
	}

	function pushCustomVariable(index, name, value, scope) {
		if (value == null || value === "") return;
		window._uxa.push(["setCustomVariable", index, name, String(value).slice(0, 100), scope]);
	}

	const refad = readCookie("refad");
	pushCustomVariable(1, "refad", refad, 3);

	if (typeof CS_CONF === "undefined") {
		window._uxa.push(["setPath", path]);

		const src = `//t.contentsquare.net/uxa/${id}.js`;
		if (!document.querySelector(`script[src="${src}"]`)) {
			const mt = document.createElement("script");
			mt.type = "text/javascript";
			mt.async = true;
			mt.src = src;
			document.getElementsByTagName("head")[0].appendChild(mt);
		}
	}
}
